<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '520px' }"
    :header="'NOTAS: ' + data_comentario.nombre_cliente"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-8">
          <span
            ><strong>SELECCIONE MÉDICO: <small class="p-invalid">*</small></strong></span
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
            <Dropdown
              :disabled="existe_medico_logueado"
              v-model="medicoSelected"
              :options="medicos"
              optionLabel="nombre_completo"
              optionValue="id"
              placeholder="SELECCIONE UN MÉDICO"
              class="p-inputtext-sm mr-2"
              :filter="true"
              v-tooltip.top="'Seleccione un médico'"
            />
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>FECHA:</strong></span>
          <InputText v-model="data_comentario.fecha" type="datetime-local" class="p-inputtext-sm" />
        </div>

        <div class="field col-12">
          <span
            ><strong>NOTAS: <small class="p-invalid">*</small></strong></span
          >
          <Textarea v-model="data_comentario.observaciones" rows="2" />
        </div>

        <div class="field col-12">
          <span><strong>MEDICAMENTOS:</strong></span>
          <Textarea v-model="data_comentario.medicamentos" autoResize rows="1" />
        </div>

        <!-- FIRMA CLIENTE -->
        <div class="field col-12">
          <span><strong>FIRMA DEL CLIENTE:</strong></span>
          <div style="border: 2px dashed #aaa; border-radius: 6px; background: #fff; position: relative">
            <canvas
              ref="firmaCanvas"
              width="500"
              height="120"
              style="display: block; cursor: crosshair; border-radius: 6px; width: 100%"
              @mousedown="iniciarFirma"
              @mousemove="dibujarFirma"
              @mouseup="detenerFirma"
              @mouseleave="detenerFirma"
              @touchstart.prevent="iniciarFirmaTactil"
              @touchmove.prevent="dibujarFirmaTactil"
              @touchend="detenerFirma"
            ></canvas>
            <Button
              icon="pi pi-refresh"
              class="p-button-rounded p-button-text p-button-warning p-button-sm"
              style="position: absolute; bottom: 6px; right: 6px"
              v-tooltip.top="'Limpiar firma'"
              @click="limpiarFirma"
            />
          </div>
          <small style="color: #888">Firme en el recuadro con el mouse o dedo</small>
        </div>
      </div>
    </div>

    <template #footer>
      <Button label="CANCELAR" icon="pi pi-times" class="p-button-secondary p-button-lg" @click="ocultarDialog" />
      <Button
        label="GUARDAR"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        @click="guardarComentario"
        :loading="guardando"
      />
    </template>
  </Dialog>
</template>

<script>
import PlanTratamientoService from '@/service/PlanTratamientoService'

export default {
  emits: ['closeModal', 'actualizarListado'],
  props: {
    show: { type: Boolean, default: false },
    comentario: { type: Object, default: () => ({}) },
    medicos: { type: Array, default: () => [] }
  },
  planTratamientoService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_comentario: { ...this.comentario },
      guardando: false,
      medicoSelected: null,
      existe_medico_logueado: false,
      dibujando: false,
      firmaVacia: true
    }
  },
  created() {
    this.planTratamientoService = new PlanTratamientoService()
  },
  methods: {
    // ---------- firma ----------
    getCtx() {
      const canvas = this.$refs.firmaCanvas
      const ctx = canvas.getContext('2d')
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = 2
      ctx.lineCap = 'round'
      return { canvas, ctx }
    },
    getPosCanvas(event, canvas) {
      const rect = canvas.getBoundingClientRect()
      return {
        x: (event.clientX - rect.left) * (canvas.width / rect.width),
        y: (event.clientY - rect.top) * (canvas.height / rect.height)
      }
    },
    iniciarFirma(event) {
      const { canvas, ctx } = this.getCtx()
      const pos = this.getPosCanvas(event, canvas)
      ctx.beginPath()
      ctx.moveTo(pos.x, pos.y)
      this.dibujando = true
    },
    dibujarFirma(event) {
      if (!this.dibujando) return
      const { canvas, ctx } = this.getCtx()
      const pos = this.getPosCanvas(event, canvas)
      ctx.lineTo(pos.x, pos.y)
      ctx.stroke()
      this.firmaVacia = false
    },
    detenerFirma() {
      this.dibujando = false
    },
    iniciarFirmaTactil(event) {
      this.iniciarFirma(event.touches[0])
    },
    dibujarFirmaTactil(event) {
      this.dibujarFirma(event.touches[0])
    },
    limpiarFirma() {
      const { canvas, ctx } = this.getCtx()
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.firmaVacia = true
    },
    obtenerFirmaBase64() {
      if (this.firmaVacia) return null
      const canvas = this.$refs.firmaCanvas
      const tmpCanvas = document.createElement('canvas')
      tmpCanvas.width = canvas.width
      tmpCanvas.height = canvas.height
      const tmpCtx = tmpCanvas.getContext('2d')
      tmpCtx.fillStyle = '#ffffff'
      tmpCtx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height)
      tmpCtx.drawImage(canvas, 0, 0)
      return tmpCanvas.toDataURL('image/png')
    },
    // ---------- modal ----------
    ocultarDialog() {
      this.mostrarModal = false
      this.guardando = false
      this.medicoSelected = null
      this.data_comentario = {}
      this.firmaVacia = true
      this.$emit('closeModal')
    },
    // ---------- guardar ----------
    guardarComentario() {
      if (this.guardando) return
      this.guardando = true

      if (!this.medicoSelected) {
        this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Seleccione un médico', life: 4000 })
        this.guardando = false
        return
      }
      if (!this.data_comentario.observaciones) {
        this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'Ingrese una observación', life: 4000 })
        this.guardando = false
        return
      }

      // Fix fecha: si viene solo date agregar hora actual
      let fecha = this.data_comentario.fecha
      if (fecha && fecha.length === 10) {
        const ahora = new Date()
        const hh = String(ahora.getHours()).padStart(2, '0')
        const mm = String(ahora.getMinutes()).padStart(2, '0')
        fecha = `${fecha}T${hh}:${mm}`
      }

      const datos = {
        ...this.data_comentario,
        fecha,
        medico_id: this.medicoSelected,
        nombre_medico: this.medicos.find((m) => m.id === this.medicoSelected)?.nombre_completo ?? '',
        firma_cliente: this.obtenerFirmaBase64()
      }

      this.planTratamientoService.guardarComentario(datos).then((data) => {
        if (data.success === false) {
          this.$toast.add({ severity: 'error', summary: 'Error!', detail: data.message, life: 4000 })
          this.guardando = false
        } else {
          this.$toast.add({ severity: 'success', summary: 'Éxito!', detail: data.message, life: 3000 })
          this.$emit('actualizarListado')
          this.ocultarDialog()
        }
      })
    }
  },
  watch: {
    show(val) {
      this.mostrarModal = val
      if (val) {
        // inicializar fecha con hora actual al abrir
        this.$nextTick(() => {
          if (!this.data_comentario.fecha || this.data_comentario.fecha.length === 10) {
            const ahora = new Date()
            const pad = (n) => String(n).padStart(2, '0')
            this.data_comentario.fecha = `${ahora.getFullYear()}-${pad(ahora.getMonth() + 1)}-${pad(
              ahora.getDate()
            )}T${pad(ahora.getHours())}:${pad(ahora.getMinutes())}`
          }
          this.limpiarFirma()
        })
      }
    },
    comentario(val) {
      this.data_comentario = { ...val }
      // setear fecha con hora actual
      const ahora = new Date()
      const pad = (n) => String(n).padStart(2, '0')
      this.data_comentario.fecha = `${ahora.getFullYear()}-${pad(ahora.getMonth() + 1)}-${pad(ahora.getDate())}T${pad(
        ahora.getHours()
      )}:${pad(ahora.getMinutes())}`

      if (val.medico_id) {
        this.medicoSelected = val.medico_id
        this.existe_medico_logueado = true
      } else {
        this.existe_medico_logueado = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>
